import { autoinject } from "aurelia-dependency-injection";
import { RequestClientService } from "../basic/request-client.service";
import type { AddEntityAttachmentsRequest, AddEntityAttachmentsResponse, GetEntityAttachmentsRequest, GetEntityAttachmentsResponse, RemoveCorrespondenceAttachmentsRequest, RemoveEntityAttachmentsResponse } from "../../models/attachments.models";
import { ConfigService } from "../basic/config.service";
import { Urls } from "../../constants/attachment.constants";

@autoinject
export class AttachmentsClientService {

    public baseUrl: string;

    constructor(private requestClient: RequestClientService, private configService: ConfigService) {
        this.baseUrl = this.configService.config.urls.rightShipPlatformApiUrl;
    }

    public saveAttachments(request: AddEntityAttachmentsRequest): Promise<AddEntityAttachmentsResponse> {
        return this.requestClient.postFormData(this.baseUrl + "/" + Urls.RightShipAttachment, request);
    }

    public getSharedAccessSignatureToken(entityAttachmentId: number, downloadFile: boolean): Promise<string> {
        return this.requestClient.get(this.baseUrl + "/" + Urls.GetSharedAccessSignatureToken, { entityAttachmentId, downloadFile });
    }

    public getSharedAccessSignatureTokenFromPath(url: string, fileName:string): Promise<string> {
        return this.requestClient.get(this.baseUrl + "/" + Urls.GetSharedAccessSignatureTokenFromPath, { url, fileName });
    }

    public deleteAttachments(request: RemoveCorrespondenceAttachmentsRequest): Promise<RemoveEntityAttachmentsResponse> {
        return this.requestClient.post(this.baseUrl + "/" + Urls.DeleteCorrespondenceAttachments, {}, request);
    }

    public getAttachments(request: GetEntityAttachmentsRequest): Promise<GetEntityAttachmentsResponse> {
        return this.requestClient.post(this.baseUrl + "/" + Urls.GetAttachments, {}, request);
    }
}
